module.exports = __webpack_public_path__ + "static/media/599.756(35).1ff9e808.pdf";